import { Box } from "@chakra-ui/react";
import LandingFooter from "@components/LandingFooter/LandingFooter";
import LoadingPage from "@components/Loader/LoadingPage";
import { useUserStore } from "@providers/auth";
import type { ReactNode } from "react";
import Header from "../../../components/Header/Header";

const TicketingLayout = ({
  children,
  showHeader: showHeader = true,
  showFooter: showFooter = true,
  bg: bg = "bg-[url('/images/auth-bg.svg')]",
  maxW: maxW = "1024px",
  allowToggleTheme,
  landingUrl = "/",
  appUrl = "/",
}: {
  children?: ReactNode;
  showFooter?: boolean;
  showHeader?: boolean;
  bg?: string;
  maxW?: string;
  allowToggleTheme?: boolean;
  landingUrl?: string;
  appUrl?: string;
}) => {
  const authenticating = useUserStore((state) => state.authenticating);
  if (authenticating) return <LoadingPage />;

  return (
    <div
      className={
        "min-h-screen w-screen relative bg-cover dark:bg-neutral-900 bg-neutral-10 bg-center bg-no-repeat ticketing-layout-bg " +
        bg
      }
    >
      <div className="flex flex-col flex-grow min-h-screen ">
        {showHeader && (
          <Header
            maxW={maxW}
            allowToggleTheme={allowToggleTheme}
            landingUrl={landingUrl}
            appUrl={appUrl}
          />
        )}
        <div className="flex flex-col flex-grow p-0 h-full relative ">
          <Box
            as="main"
            className="flex flex-col flex-grow relative z-0 w-full mx-auto"
            maxW={maxW}
          >
            {children}
          </Box>
          {showFooter && <LandingFooter />}
        </div>
      </div>
    </div>
  );
};

export default TicketingLayout;
